export const energyTypes = [
	'Fioul',
	'Bois',
	'Gaz',
	'Electricité',
	// 'Eau chaude',
	'Fioul condensation',
	'Gaz condensation',
]